import { create } from 'zustand';
import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API}/api/auth`;

axios.defaults.withCredentials = true;

export const useAuthStore = create((set) => ({
    user: null,
    isAuthenticated: false,
    error: null,
    isLoading: false,
    isCheckingAuth: true,

    signup: async (email, password, name, degree, gradYear) => {
        set({ isLoading: true, error: null });
        try {
            const response = await axios.post(`${API_URL}/signup`, { UserEmail: email, password, Name: name, Degree: degree, Grad_Year: gradYear });
            set({ user: response.data.user, isAuthenticated: true, isLoading: false });
        } catch (error) {
            set({ error: error.response.data.message || "Error signing up", isLoading: false });
            throw error;
        }
    },
    login: async (email, password) => {
        set({ isLoading: true, error: null });
        try {
            const response = await axios.post(`${API_URL}/login`, { UserEmail: email, password });
            set({ user: response.data.user, isAuthenticated: true, isLoading: false, error: null });
        } catch (error) {
            set({ error: error.response.data.message || "Error logging in", isLoading: false });
            throw error;
        }
    },
    logout: async () => {
        set({ isLoading: true, error: null });
        try {
            await axios.post(`${API_URL}/logout`);
            set({ user: null, isAuthenticated: false, error: null, isLoading: false });
        } catch (error) {
            set({ error: "Error logging out", isLoading: false });
            throw error;
        }
    },
    verifyEmail: async (code) => {
        set({ isLoading: true, error: null });
        try {
            const response = await axios.post(`${API_URL}/verify-email`, { code });
            set({ user: response.data.user, isAuthenticated: true, isLoading: false });
        } catch (error) {
            set({ error: error.response.data.message || "Error verifying email", isLoading: false });
            throw error;
        }
    },
    CheckAuth: async () => {
        set({ isCheckingAuth: true, error: null });
        try {
            const response = await axios.get(`${API_URL}/check-auth`);
            set({ user: response.data.user, isAuthenticated: true, isCheckingAuth: false });
        } catch (error) {
            set({ error: null, isCheckingAuth: false, isAuthenticated: false });
        }
    },
    forgotPassword: async (email) => {
        set({ isLoading: true, error: null });
        try {
            const response = await axios.post(`${API_URL}/forgot-password`, { UserEmail: email });
            set({ message: response.data.message, isLoading: false });
        } catch (error) {
            set({ isLoading: false });
            throw error;
        }
    },
    resetPassword: async (token, password) => {
        set({ isLoading: true, error: null });
        try {
            await axios.post(`${API_URL}/reset-password/${token}`, { password });
            set({ isLoading: false, error: null });
        } catch (error) {
            set({ isLoading: false, error: error.response.data.message || "Error resetting password" });
        }
    },
    resendVerificationEmail: async (email) => {
        set({ error: null, isResending: false });
        try {
            await axios.post(`${API_URL}/resend-verification-email`, { UserEmail: email });
            set({ isLoading: false, error: null });
        } catch (error) {
            set({ error: error.response.data.message || "Error resending verification email" });
            throw error;
        }
    },

    // ── Google / Auth0 ──────────────────────────────────────────────
    handleGoogleAuth: async (accessToken) => {
        set({ isLoading: true, error: null });
        try {
            const response = await axios.post(
                `${API_URL}/google-token`,
                {},
                { headers: { Authorization: `Bearer ${accessToken}` } }
            );
            set({ user: response.data.user, isAuthenticated: true, isLoading: false });
            return response.data;   // caller reads needsProfileCompletion
        } catch (error) {
            set({ error: error.response?.data?.message || 'Google sign-in failed', isLoading: false });
            throw error;
        }
    },

    completeProfile: async (degree, gradYear) => {
        set({ isLoading: true, error: null });
        try {
            const response = await axios.post(`${API_URL}/complete-profile`, {
                Degree: degree,
                Grad_Year: gradYear,
            });
            set({ user: response.data.user, isLoading: false });
            return response.data;
        } catch (error) {
            set({ error: error.response?.data?.message || 'Failed to save profile', isLoading: false });
            throw error;
        }
    },
}));